// Core Modules
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

// External Modules
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

// Components
import { UserSettingsComponent } from '@layout/user-settings/user-settings.component';

// Services
import { AccessControlService } from '@core/services/access-control/access-control.service';
import { AuthService } from '@core/services/auth/auth.service';
import { ConfigService } from '@core/services/config/config.service';

// Models
import { HeaderContentModel } from '@shared/models/header-content.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [NgbTooltipModule, RouterLink, UserSettingsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  // Bindings
  public readonly hideSettings = input<boolean>(false);

  // Events
  /** Emitted when the mobile menu button is tapped; the shell opens the nav drawer. */
  public readonly toggleNav = output<void>();

  // Injectors
  private readonly accessControl = inject(AccessControlService);
  public readonly authService = inject(AuthService);
  private readonly configService = inject(ConfigService);

  // Public Members
  public readonly headerContents: HeaderContentModel = this.configService.getContents('header');
  /** Home icon target — the first destination the user's scopes admit, matching the side-nav rail. */
  public readonly landingRoute = this.accessControl.landingRoute;
  public isMenuCollapsed = false;
}
